import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';

export type OsasQuestionnairesCustomControlData = {
    processQuestionnaireResponseIds?: string[];
};

export const osasShowMijnKsyosQuestionnairesSchema = Koi.object({
    processQuestionnaireResponseIds: Koi.array().items(Koi.string()).optional(),
});

export type OsasShowMijnKsyosQuestionnairesReadKey = 'questionnaireProgressItems' | 'questionnaireResultsItems';

export type OsasShowMijnKsyosQuestionnairesReadLabel = 'questionnaireProgressItems' | 'questionnaireResultsItems';

export type OsasShowMijnKsyosQuestionnairesReadSectionTitle = 'Voortgang vragenlijsten';

export const osasShowMijnKsyosQuestionnairesReadSchema: TypedReadSchema<
    OsasShowMijnKsyosQuestionnairesReadKey,
    OsasShowMijnKsyosQuestionnairesReadLabel,
    OsasShowMijnKsyosQuestionnairesReadSectionTitle
>[] = [
    {
        items: [
            { key: 'questionnaireProgressItems', label: 'questionnaireProgressItems' },
            { key: 'questionnaireResultsItems', label: 'questionnaireResultsItems' },
        ],
        sectionTitle: 'Voortgang vragenlijsten',
    },
];
